import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { LayoutStore } from './layout.store';

@Injectable({
    providedIn: 'root'
})
export class LayoutQuery extends BaseQuery {

  constructor(store: LayoutStore) {
        super(store);
    }


}
